
<template>
    <div class="installPage">
        <div class="bgBox"><img src="./../../../assets/usercenter/usercenter-bg.png" alt=""></div>
        <div class="top"></div>
        <div class="header">
            <router-link to="/home" tag="i"> <img src="./../../../assets/home/back.jpg" alt=""> </router-link>
            <span>入口安装</span>
        </div> 
        <div class="box">
            <p class="title">简要说明</p>
            <ul>
                <li>1、应用无法启动时,可以通过入口找到新的下载地址。</li>
                <li>2、两天内没有从入口进入,系统会再次提示安装入口。</li>
                <li>3、从入口进入后,页面会自动关闭。</li>
                <li>4、如果两天内没有从入口进入或者二维码校验,无法提现。</li>
            </ul>
            <div class="installBox">
                <!-- <router-link tag="p" to="" class="install">立即安装</router-link> -->
                <p class="install" @click="openSafari">立即安装</p>
                <p class="text">轻松简单 一键安装</p>
            </div>
        </div>
    </div>
</template>

<script>
import qs from 'qs'
export default {
    methods:{
        openSafari(){
            this.$bridge.callhandler('buildRelationShip', {
                rsUrl: 'http://img.bjyiyoutech.com/static/app/ihongbao.mobileconfig',
                },(data) => {
            })
        }
    },
    created(){

        let token = localStorage.getItem("UserToken");
        let uid = localStorage.getItem("UID");
        this.$axios.post("/api/user/isopenrukou", 
        qs.stringify({
        token : token,
        uid : uid,
        })
        ).then(res=>{
        })
        
    },
}
</script>

<style lang="scss" scoped>
    .bgBox{
        width:100%;
        height:3.00rem;
        position: absolute;
        top:.60rem;
        z-index: -1;
    }
    .top{
        height:20px;
    }
    .header{
        width:90%;
        height:.40rem;
        margin-left: 5%;
        display: flex;
        justify-content: center;
        align-items: center;
        position:relative;
        span{
            font-size: .18rem;
            line-height: .40rem;
        }
        i{
            position:absolute;
            left:0.05rem;
            width:.26rem;
            height:.16rem;
            padding-right:.16rem;
        }
    }
    .box{
        width:90%;
        height:90%;
        padding:.24rem;
        margin:5%;
        border-radius:.06rem;
        background:#fff;
        .title{
            font-size: .18rem;
            color:#333333;
        }
        ul{
            margin-top:.10rem;
            li{
                font-size: .16rem;
                color:#6d6868;
            }
        }
        .installBox{
            margin-top:.40rem;
            width:100%;
            display:flex;
            align-items: center;
            flex-direction: column;
            .install{
                width:1.10rem;
                height:.40rem;
                font-size: .17rem;
                text-align: center;
                line-height: .40rem;
                background-image: linear-gradient(112deg, #FFDF42 0%, #FFEC77 100%);
                border-radius: .18rem;
            }
            .text{
                margin:.10rem;
                font-size: .12rem;
                color: #9B9B9B;
            }
        }
    }
</style>

